import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { keyBy } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { AnimalGroupInfo } from "../GQLCalls/getAnimalGroupCall";

export type AnimalGroupItem = DynamicDataObk<AnimalGroupInfo[]>

const animalGroupDataAdapter = createEntityAdapter({
  selectId: (item: AnimalGroupItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<AnimalGroupItem, string>, {con, data}: AnimalGroupItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const dataDictionary = keyBy(state.entities[identifier].data, "animalGroupId")
    data.forEach((entry) => dataDictionary[entry.animalGroupId] = entry)
    const newPayload = {con, data: Object.values(dataDictionary)}
    animalGroupDataAdapter.upsertOne(state, newPayload);
  } else { animalGroupDataAdapter.addOne(state, {con, data})}
}

const animalGroupsSlice = createSlice({
  name: "animalGroups",
    initialState: animalGroupDataAdapter.getInitialState<AnimalGroupItem[]>([]),
      reducers: {
        maintained: (state, {payload}:PayloadAction<AnimalGroupItem>) => {
          mergePayloadAndState(state, payload);
        }
    }
})

export const animalGroupActions = animalGroupsSlice.actions;
export default animalGroupsSlice.reducer;